import React, { useEffect, useMemo, useState } from 'react';
import CoinList from './components/CoinList';
import './App.css';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function App() {
  const getInitialMode = () => {
    const saved = window.localStorage.getItem('themeMode');
    if (saved === 'light' || saved === 'dark') return saved;
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'light';
  };

  const [mode, setMode] = useState(getInitialMode);

  useEffect(() => {
    window.localStorage.setItem('themeMode', mode);
  }, [mode]);

  const theme = useMemo(() => createTheme({
    palette: { mode }
  }), [mode]);

  const toggleMode = () => setMode(prev => (prev === 'light' ? 'dark' : 'light'));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 16 }}>
          <h2 style={{ margin: 0 }}>BSC, AVAX, and SOL Coin Analyzer</h2>
          <button onClick={toggleMode}>
            {mode === 'dark' ? 'Switch to Light' : 'Switch to Dark'}
          </button>
        </div>
        <CoinList />
      </div>
    </ThemeProvider>
  );
}

export default App;
